module.exports = __webpack_public_path__ + "img/124.5d59be74.png";